module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_06-a6489c0780edcd90994d19dee996fc97.jpg";